module.exports = __webpack_public_path__ + "static/media/ubuntu.8d29ef43.png";